import { StrategyBuilderFunction, EMPTY_STRATEGY } from 'utils/shared/optionProfitCalculator/types';
import { addShortCall, addShortPut } from 'utils/shared/optionProfitCalculator/addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  DEFAULT_STOCK_POSITION,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
} from 'utils/shared/optionProfitCalculator/utils';

export const coveredShortStraddle: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  const strikePrice = findClosestStrikePrice(strikesAtExpiration, spot);

  const stockPosition = {
    price: spot,
    quantity: DEFAULT_STOCK_POSITION * contractMultiplier, // 100 shares per strategy unit
  };

  const cashPosition = {
    amount: strikePrice * DEFAULT_STOCK_POSITION,
  };

  return {
    optionPositions: [
      // Sell a call option
      addShortCall({
        strike: strikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[strikePrice]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[strikePrice]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Sell a put option
      addShortPut({
        strike: strikePrice,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[strikePrice]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[strikePrice]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [stockPosition],
    cashPositions: [cashPosition],
  };
};
